import { PasswordErrorType } from '../../pages/SignUpPage/interfaces';

export const PASSWORD_ERROR_MESSAGES = {
  [PasswordErrorType.MinLength]: 'validations.password.minLength',
  [PasswordErrorType.OneLowerCase]: 'validations.password.oneLowerCase',
  [PasswordErrorType.OneUpperCase]: 'validations.password.oneUpperCase',
  [PasswordErrorType.OneNumber]: 'validations.password.oneNumber',
  [PasswordErrorType.Match]: 'validations.password.match',
};
